// config.js - Конфигурация приложения (обновленная для Bot API)

import { logger } from './utils/logger.js';

const getEnvVar = (name, defaultValue = '') => {
  // Для Parcel v2 используем process.env напрямую
  // Parcel заменит эти значения во время сборки
  try {
    const value = process.env[name];
    return value !== undefined ? value : defaultValue;
  } catch {
    return defaultValue;
  }
};

export const config = {
  // === НОВАЯ КОНФИГУРАЦИЯ ДЛЯ BOT API ===
  // URL Telegram Bot API
  BOT_API_URL: process.env.VITE_BOT_API_URL || 'http://localhost:8000',
  
  // Username бота (без @)
  BOT_USERNAME: process.env.VITE_BOT_USERNAME || 'Fish_way_for_you_bot',

  // Яндекс OAuth Client ID
  YANDEX_CLIENT_ID: process.env.VITE_YANDEX_CLIENT_ID || '',
  
  // Режим работы: только 'bot-api'!
  API_MODE: 'bot-api', // Зафиксировано! Legacy режим больше не поддерживается
  
  // === LEGACY КОНФИГУРАЦИЯ - НЕ ИСПОЛЬЗУЕТСЯ! ===
  // Вся работа с Google Sheets теперь идет через Bot API
  // Эти параметры оставлены только для обратной совместимости
  // SHEET_ID: getEnvVar('SHEET_ID', ''), // Удалено из кода!
  // GOOGLE_API_KEY: getEnvVar('GOOGLE_API_KEY', ''), // Не используется!
  // APPS_SCRIPT_URL: getEnvVar('APPS_SCRIPT_URL', ''), // Не используется!
  // SHEET_URL: '', // Не используется!
  
  // === НАСТРОЙКИ ПРИЛОЖЕНИЯ ===
  APP_NAME: 'Путь рыбы',
  APP_VERSION: '2.0.0',
  
  // Логирование
  DEBUG: getEnvVar('DEBUG', 'false') === 'true',
  
  // Кэширование
  CACHE_TTL: parseInt(getEnvVar('CACHE_TTL', '300000')), // 5 минут в миллисекундах
  
  // Тайм-аут запросов (в миллисекундах)
  REQUEST_TIMEOUT: parseInt(getEnvVar('REQUEST_TIMEOUT', '10000')), // 10 секунд
};

// Проверка конфигурации и вывод предупреждений
const validateConfig = () => {
  if (config.API_MODE === 'bot-api') {
    if (!config.BOT_API_URL) {
      console.error("⚠️ ВНИМАНИЕ: Не настроен VITE_BOT_API_URL!");
      console.error("Создайте файл .env и добавьте:");
      console.error("VITE_BOT_API_URL=http://localhost:8000");
    } else {
      logger.log("✅ Режим Bot API активен:", config.BOT_API_URL);
    }
    
    // Добавляем проверку BOT_USERNAME
    logger.log("🤖 Bot username:", config.BOT_USERNAME);
    logger.log("📍 Bot URL will be:", `https://t.me/${config.BOT_USERNAME}`);
  }
  // Legacy режим удален - все данные теперь через Bot API!
};

// Запускаем валидацию
validateConfig();

// Для отладки
if (config.DEBUG) {
  logger.log("Config loaded:", {
    apiMode: config.API_MODE,
    botApiUrl: config.BOT_API_URL,
    // Legacy параметры удалены
    debug: config.DEBUG,
    version: config.APP_VERSION
  });
}

// Экспортируем утилиты для работы с конфигурацией
export const ConfigUtils = {
  // Проверка, что используется новый Bot API
  isBotAPIMode: () => config.API_MODE === 'bot-api',
  
  // Legacy режим больше не поддерживается
  isLegacyMode: () => false,
  
  // Получение базового URL для API
  getAPIBaseURL: () => {
    // Только Bot API!
    return config.BOT_API_URL;
  },
  
  // Проверка готовности конфигурации
  isConfigReady: () => {
    // Только Bot API URL нужен!
    return !!config.BOT_API_URL;
  },
  
  // Получение заголовков для запросов
  getRequestHeaders: () => {
    const headers = {
      'Content-Type': 'application/json'
    };
    
    if (ConfigUtils.isBotAPIMode()) {
      // Для Bot API можно добавить дополнительные заголовки
      headers['X-Client-Version'] = config.APP_VERSION;
    }
    
    return headers;
  }
};

export default config; 